export default "__VITE_ASSET__24cd051b__"